// Ported from finster-chat/utils/sanitiseFileName.ts for web naming parity.
export const sanitiseFileName = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf(".");
  const hasExtension = lastDotIndex > 0 && lastDotIndex < fileName.length - 1;
  const name = hasExtension ? fileName.slice(0, lastDotIndex) : fileName;
  const extension = hasExtension ? fileName.slice(lastDotIndex) : "";

  const sanitizedName = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics (café → cafe)
    .replace(/[–—−]/g, "-") // Normalize dashes to hyphen
    .replace(/[^\w\s.-]/g, "") // Remove invalid characters
    .replace(/\s+/g, " ") // Collapse multiple spaces
    .replace(/[_-]+/g, (match) => (match.includes("-") ? "-" : "_")) // Collapse punctuation, prefer hyphen
    .replace(/\.{2,}/g, ".") // Collapse multiple dots
    .trim()
    .replace(/^[._-]+|[._-]+$/g, ""); // Trim leading/trailing punctuation

  const sanitizedExtension = extension.replace(/[^\w.]/g, "");

  const result =
    sanitizedName && sanitizedExtension
      ? `${sanitizedName}${sanitizedExtension}`
      : sanitizedName || sanitizedExtension;

  return result || "unnamed_file";
};
